import usernameLib from '../username'
import twilio from 'twilio-video'

/**
 * A function to get the current number of presenters in the Twilio Room
 * @param {Room} twilioRoom - The Twilio Room object
 * @param {string} localIdentity - The identity of the local user
 * @return - A count of the presenters
 */

export default function (twilioRoom: twilio.Room): number {

  const { participants } = twilioRoom
  const participantsArr = Array.from(participants, ([, v]) => v.identity)

  return participantsArr.reduce((presenterCount, identity) =>
    usernameLib.isPresenter(identity)
      ? presenterCount + 1
      : presenterCount
  , 0)

}
